import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { FEATURES } from "@/lib/data";
import { SectionHead } from "./SectionHead";

export const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionHead overline="Why Auto-Hire STL" title="Built Different." accent="" desc="We obsess over the details so your only job is to drive. Here's what sets us apart." />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden mt-14">
          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Star;
            return (
              <motion.div
                key={f.title}
                data-testid={`feature-${i}`}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group bg-[#0A0A0A] p-8 md:p-10 hover:bg-[#0F0F0F] transition-colors duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-[#F2B705]/10 border border-[#F2B705]/20 flex items-center justify-center group-hover:bg-[#F2B705] transition-colors duration-300">
                  <Icon className="text-[#F2B705] group-hover:text-black transition-colors duration-300" size={22} />
                </div>
                <h3 className="font-display font-bold text-xl mt-5">{f.title}</h3>
                <p className="text-white/50 mt-2 font-light leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
